import { render } from "./LatestImages.vue?vue&type=template&id=2348edee"
import script from "./LatestImages.vue?vue&type=script&lang=js"
export * from "./LatestImages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__